import React, { useState } from "react";
import VoucherNumberSettingsTab from "./VoucherNumberSettingsTab";
import GLSettingsTab from "./GLSettingsTab";
import GLCategory from "./GLCategory";


const tabList = ["Voucher Number Settings", "GL settings", "GL Category"];

const GLVoucherSettings = (props) => {

  const {setShowComponent,company_details} = props

  const [activeTab, setActiveTab] = useState("Voucher Number Settings");

  const renderContent = () => {
    switch (activeTab) {
      case "Voucher Number Settings":
        return <VoucherNumberSettingsTab company_details={company_details} setShowComponent={setShowComponent}/>;
      case "GL settings":
        return <GLSettingsTab company_details={company_details}/>;
      case "GL Category":
        return <GLCategory company_details={company_details}/>;
      default:
        return null;
    }
  };

  return (
    <div className="w-full  mx-auto mt-6 bg-white shadow rounded">
      <div className="border-b border-gray-200 flex">
        {tabList.map((tab) => (
          <button
            key={tab}
            onClick={() => setActiveTab(tab)}
            className={`px-6 py-3 text-sm font-medium ${
              activeTab === tab
                ? "border-b-2 border-blue-600 text-blue-600"
                : "text-gray-500 hover:text-blue-500"
            }`}
          >
            {tab}
          </button>
        ))}
      </div>

      <div className="bg-gray-50">{renderContent()}</div>
    </div>
  );
};

export default GLVoucherSettings;
